/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CopyBriefMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
    designerIds?: Types.Maybe<Array<Types.Scalars['Int']> | Types.Scalars['Int']>;
}>;

export type CopyBriefMutation = {
    __typename: 'Mutation';
    brief: { __typename: 'StructuredBrief'; id: string };
};

export const CopyBriefDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CopyBrief' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'designerIds' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'brief' },
                        name: { kind: 'Name', value: 'copyStructuredBrief' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'designerIds' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'designerIds' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                    },
                ],
            },
        },
    ],
};
export type CopyBriefMutationFn = Apollo.MutationFunction<
    CopyBriefMutation,
    CopyBriefMutationVariables
>;
export type CopyBriefComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<CopyBriefMutation, CopyBriefMutationVariables>,
    'mutation'
>;

export const CopyBriefComponent = (props: CopyBriefComponentProps) => (
    <ApolloReactComponents.Mutation<CopyBriefMutation, CopyBriefMutationVariables>
        mutation={CopyBriefDocument}
        {...props}
    />
);

/**
 * __useCopyBriefMutation__
 *
 * To run a mutation, you first call `useCopyBriefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyBriefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyBriefMutation, { data, loading, error }] = useCopyBriefMutation({
 *   variables: {
 *      id: // value for 'id'
 *      designerIds: // value for 'designerIds'
 *   },
 * });
 */
export function useCopyBriefMutation(
    baseOptions?: Apollo.MutationHookOptions<CopyBriefMutation, CopyBriefMutationVariables>
) {
    return Apollo.useMutation<CopyBriefMutation, CopyBriefMutationVariables>(
        CopyBriefDocument,
        baseOptions
    );
}
export type CopyBriefMutationHookResult = ReturnType<typeof useCopyBriefMutation>;
export type CopyBriefMutationResult = Apollo.MutationResult<CopyBriefMutation>;
export type CopyBriefMutationOptions = Apollo.BaseMutationOptions<
    CopyBriefMutation,
    CopyBriefMutationVariables
>;
